import cn from "classnames";
import { Field } from "components/shared/form";
import React, { useState } from "react";

const ScenarioCopy = (props) => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({ id: props.scenario.id, name: `Копия - ${props.scenario.name}` });

    const saveData = (e) => {
        e.preventDefault();
        setLoading(true);
        props.action(data).then((res) => {
            if (res?.id) {
                props.goToCopy(res.id);
            }
            setLoading(false);
        });
    };

    return (
        <form className={cn({ loading })} onSubmit={saveData}>
            <Field
                label="Название"
                inputProps={{ name: "name" }}
                value={data.name}
                onChange={({ value }) => setData({ ...data, name: value })}
            />
            <button className="btn btn-sm btn-brand float-right" type="submit">
                Сохранить
            </button>
        </form>
    );
};

export default ScenarioCopy;
